import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { colors } = useTheme();

  return {
    group: css`
      display: grid;
      grid-template-columns: auto;
      grid-gap: 8px;
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: 1px solid #eceef3;
    `,
    groupLabel: css`
      font-family: 'FS Dillon Bold';
      font-size: 15px;
      font-weight: 700;
      color: #011e41;
      line-height: 20px;
      text-transform: uppercase;
      letter-spacing: 0.08em;
    `,
    groupValue: css`
      font-size: 16px;
      color: ${colors.next_grey};
      line-height: 20px;
      letter-spacing: 0.02em;
      display: flex;
      gap: 4px;
      flex-wrap: wrap;
    `,
  };
};
